import * as React from "react";
import classNames from "classnames";
import { transportType } from "common/data";
import { ReactComponent as Bus } from "./images/bus.inline.svg";
import { ReactComponent as MiniBus } from "./images/minibus.inline.svg";
import { ReactComponent as Taxi } from "./images/taxi.inline.svg";
import styles from "./styles.module.scss";

const transportIcon = {
  [transportType.bus]: Bus,
  [transportType.trolleybus]: MiniBus,
  [transportType.taxi]: Taxi,
};

const TransportInfo = ({
  type = transportType.bus,
  kind,
  number,
  time,
  route,
  isTimeVisible = true,
  className = "",
}) => {
  const Icon = transportIcon[type];
  const ComponentClass = classNames(styles["transport-info"], className);
  return (
    <div className={ComponentClass}>
      <Icon />
      <div className={styles["info-container"]}>
        <p>
          {kind}
          <span className={styles.number}> {number}</span>
        </p>
        <p className={styles.route}>{route}</p>
      </div>
      {isTimeVisible && <span>{time}</span>}
    </div>
  );
};

export default TransportInfo;
